<div class="w-full h-full flex flex-col">
  <div class="p-4 bg-surface-50 rounded-2xl">
    @switch (currentStep()) {
      @case (CreateTaStepType.TRAVELLERS) {
        <create-template-travellers></create-template-travellers>
      }
      @case (CreateTaStepType.DETAILS) {
        <create-template-details></create-template-details>
      }
      @case (CreateTaStepType.ITINERARY) {
        <create-template-itinerary></create-template-itinerary>
      }
    }
  </div>
  <div class="flex justify-end gap-2 pt-4">
    <p-button size="small" label="Close" severity="secondary" data-testid="template-step-modal-close" (click)="closeDialog()" />
  </div>
</div>
